module.exports = __webpack_public_path__ + "img/Zayn.fdf0aea3.png";